export default "__VITE_ASSET__DKRxgWyr__"